module.exports = __webpack_public_path__ + "img/logo.e3ef0e22.png";